import { render, staticRenderFns } from "./PopupEditDataProcessor.vue?vue&type=template&id=a85c675e&scoped=true&"
import script from "./PopupEditDataProcessor.vue?vue&type=script&lang=js&"
export * from "./PopupEditDataProcessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85c675e",
  null
  
)

export default component.exports